import React, { useState, useEffect } from 'react';
import PmModuleStyle from '../styles/pm.module.css';
import animation_1 from '../assets/animation_1.png';
import animation_2 from '../assets/animation_2.png';
// import animation_3 from '../assets/animation_3.png';

const CalcAnimation = ({ simObj, pmPopup }) => {
  const [currentImage, setCurrentImage] = useState(animation_1);

  useEffect(() => {
    let counter = 1;

    const intervalId = setInterval(() => {
      // Change the image every 10 seconds
      counter++;
      if (counter > 2) {
        counter = 1;
      }

      switch (counter) {
        case 1:
          setCurrentImage(animation_1);
          break;
        case 2:
          setCurrentImage(animation_2);
          break;
        default:
          break;
      }
    }, 20000); // Change image every 20 seconds

    return () => clearInterval(intervalId);
  }, []); // Run only once on component mount

  return (
    <div className={`${PmModuleStyle["projected-animation"]} ${pmPopup?.pmKpis ? `show ${PmModuleStyle['show']}` : ''}`}>
      <div className={`${PmModuleStyle['_image']}`}>
        <img src={currentImage} alt="" style={{ width: '245px' }} />
      </div>
    </div>
  );
};

export default CalcAnimation;
